mutation DELETE_FACILITY_MEDIA ($id: UUID!) {
  deleteFacilityMedia (id: $id) {
    error
    success
  }
}
